export const M_SET_TOKEN = 'setToken';
export const M_SET_USER = 'setUser';
export const M_SET_LOADING = 'setLoading';